import React from "react";
import SearchSvg from "#/src/components/SearchSvg";

interface Props {
  onQuery: (query: string) => void
}

export function Header({onQuery}: Props) {
  function onEnterCheck(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      onQuery((document.getElementById("blogSearch") as HTMLInputElement).value);
    }
  }

  return <header className="blog-header">
    <div className="container-xxl">
      <div className="d-flex flex-column text-center">
        <h2 className="blog-main-title mb-0">JaRock Blog</h2>
        <div className="flex-input">
          <input id={"blogSearch"} type="text" className="form-search" placeholder="Wyszukaj" aria-label="Wyszukaj" aria-describedby="button-addon2"
                 onKeyDown={onEnterCheck} autoComplete={"off"}/>
          <button className="btn-form" type="button" id="button-addon2" onClick={() => onQuery((document.getElementById("blogSearch") as HTMLInputElement).value)}>
            <SearchSvg/>
          </button>
        </div>
      </div>
    </div>
  </header>
}